import script from "./Nopathological.vue?vue&type=script&setup=true&lang=js"
export * from "./Nopathological.vue?vue&type=script&setup=true&lang=js"

import "./Nopathological.vue?vue&type=style&index=0&id=79533e79&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79533e79"]])

export default __exports__